// extracted by mini-css-extract-plugin
module.exports = {"pasteHighlight":"styles-module--pasteHighlight--iBaMD"};